<aside #sidebar>
  <div class="wrapper">
    @if (notLoggedIn$ | async) {
      <mat-card appearance="outlined" class="warning" @slideUpDown>
        <mat-card-title class="d-flex align-items-center justify-content-between">
          <span>Warning</span>
          <mat-icon>warning</mat-icon>
        </mat-card-title>
        <mat-card-content>
          You are not logged in, and will see a limited subset of the available services. Please login
        </mat-card-content>
      </mat-card>
    }
    <form [formGroup]="searchForm" #form>
      <mat-form-field>
        <input #searchInput matInput color="secondary" placeholder="Search service" formControlName="search"
          autocomplete="off">
      </mat-form-field>

    </form>
    @if ( services$ | async; as services) {
      <div class="list">
        @if ((services | fusejs:searchTerms:searchOptions); as fusejsServices) {
          @for (service of fusejsServices; track service) {
            <button mat-button class="w-100" (click)="selectService(service, $event)" [attr.title]="service.Name">
              <span [innerHTML]="service.fuseJsHighlighted.Name"></span>
              <div class="name-space" [innerHTML]="service.fuseJsHighlighted.Namespace"></div>
            </button>
          }
          @if (fusejsServices?.length === 0 && services.length > 0) {
            <div class="pl-2">
              No results found for '{{ searchForm.get('search').value }}'
            </div>
          }
        }
      </div>
    }
    <eva-drag direction="x" [showIcon]="false" [elem]="sidebar"></eva-drag>
  </div>
</aside>

<main>
  @if (selectedService$.value) {
    <eva-tester [selectedService$]="selectedService$"></eva-tester>
  } @else {
    <eva-empty-state title="Select a service to get started" icon="list"></eva-empty-state>
  }
</main>

<eva-tester-status-bar></eva-tester-status-bar>
